export default __webpack_public_path__ + "static/media/location.e3d5eb1c.svg";